"use strict";
import React from "react";
import PropTypes from "prop-types";
import loaders from "./loaders";

const getStyle = (inline) => {

    return {
        display: inline ? 'inline-block' : 'block'
    }
};

const StatusLoader = ({loading = false, loader, inline, children}) => {
    if(typeof(loader) === 'function') {
        loader = loader();
    }
    let component = loading ? loader : children;

    return <div style={getStyle(inline)}>
        {component}
    </div>;
};

StatusLoader.propTypes = {
    loading: PropTypes.bool.isRequired,
    inline: PropTypes.bool
};
StatusLoader.defaultProps = {
    loader: () => loaders.loader,
    inline: false
};

module.exports = StatusLoader;